import 'chart.js/auto';
import "chartjs-adapter-date-fns";

import { Chart } from 'chart.js';
import { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import annotationPlugin from 'chartjs-plugin-annotation';

import routes from "./routes/routes";
import { auth } from "./config/firebase";
import { DataProvider } from "./components/data/DataContext";

import Loading from './components/layout/Loading';
import AuthChecker from "./components/auth/AuthChecker";
import ClubChecker from "./components/auth/ClubChecker";
import AdminChecker from './components/auth/AdminChecker';
import ConsentBanner from './components/auth/ConsentBanner';

// for some reason this plugin needs global registration to work...sigh
Chart.register(annotationPlugin);

function App() {
    const [loading, setLoading] = useState(true);
    const [userId, setUserId] = useState<null | string>(null);

    useEffect(() => {
        auth.onAuthStateChanged((user) => {
            if (user) {
                // console.info("User detected.");
                setUserId(user.uid); // set the user ID when they're logged in
            } else {
                // console.info("No user detected");
                setUserId(null); // clear the user ID when they're not logged in
            }

            setLoading(false);
        });
    }, []);

    if (loading) {
        return <Loading />;
    }

    return (
        <BrowserRouter basename={process.env.PUBLIC_URL}>
            <ConsentBanner /> {/* Add the ConsentBanner here */}
            <Routes>
                {routes.map((route, index) => (
                    <Route
                        key={index}
                        path={route.path}
                        element={
                            route.protected ?
                                <AuthChecker>
                                    {userId ?
                                        <DataProvider userId={userId}>
                                            {route.adminOnly || route.creatorOnly ? (
                                                <AdminChecker>
                                                    {route.clubOnly ? (
                                                        <ClubChecker>
                                                            <route.component />
                                                        </ClubChecker>
                                                    ) : (
                                                        <route.component />
                                                    )}
                                                </AdminChecker>
                                            ) : route.clubOnly ? (
                                                <ClubChecker>
                                                    <route.component />
                                                </ClubChecker>
                                            ) : (
                                                <route.component />
                                            )}
                                        </DataProvider>
                                        :
                                        <Loading />
                                    }
                                </AuthChecker>
                                :
                                <route.component />

                        }
                    />
                ))}
            </Routes>
        </BrowserRouter>
    );
}

export default App;
